// Interface

import { ApiUserRole } from '@/enum/ApiUserRole'
import util from '@/utils/classToObject'
import { IAuthState } from './state'

export class AuthGetter {
  public isAuthenticated(state: IAuthState) {
    return state.user && state.user.id > 0
  }
  public authStatus(state: IAuthState) {
    return state.authStatus
  }  
  public user(state: IAuthState) {
    return state.user
  }
  public userSecurity(state: IAuthState) {
    return state.userSecurity
  }
  public renewTokenId(state: IAuthState) {
    return state.renewTokenId
  }
  public redirectPath(state: IAuthState) {
    return state.redirectPath
  }
  public isCentralWeb(state: IAuthState){
    return state.user.usrRole == ApiUserRole.CentralWeb
  }
  public isAdmin(state: IAuthState) {
    return state.user.usrRole == ApiUserRole.Admin
  }  
  public isRoomService(state: IAuthState) {
    return state.user.usrRole == ApiUserRole.RoomService
  }
  public isReception(state: IAuthState) {
    return state.user.usrRole == ApiUserRole.Reception
  }
  public isClient(state: IAuthState) {
    return state.user.usrRole == ApiUserRole.Client
  }
  public isVisiteur(state: IAuthState) {
    return state.user.usrRole == ApiUserRole.Visiteur
  }
  public canRoomService(state: IAuthState) {
    return state.user.usrRole == ApiUserRole.RoomService || state.user.usrRole == ApiUserRole.Admin || state.user.usrRole == ApiUserRole.CentralWeb
  }  
  public canReception(state: IAuthState) {
    return state.user.usrRole == ApiUserRole.Reception || state.user.usrRole == ApiUserRole.RoomService || state.user.usrRole == ApiUserRole.Admin || state.user.usrRole == ApiUserRole.CentralWeb
  }  
  public canAdmin(state: IAuthState) {
    return state.user.usrRole == ApiUserRole.Admin || state.user.usrRole == ApiUserRole.CentralWeb
  }  
  
  public canOrder(state: IAuthState) {
    return (state?.user?.currentSejour?.id ?? 0) > 0
  } 
  public canAccess(state: IAuthState) {
    return (roles:Array<string>) => {
      return state.user.usrRole == ApiUserRole.CentralWeb              
          || roles.some(r =>               
              (r != "CentralWeb" && state.user.usrRole == ApiUserRole.Admin) 
           ||( r == "RoomService" && state.user.usrRole == ApiUserRole.RoomService) 
           || (r == "Reception" && state.user.usrRole == ApiUserRole.Reception)
           || (r == "Visiteur" && state.user.usrRole == ApiUserRole.Visiteur)
           || (r == "Client" && state.user.usrRole == ApiUserRole.Client)
      )
    } 
  }


}

export default util.classToObject(AuthGetter)
